"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationBackupModel = exports.CONFIGURATION_BACKUP_STATUS = void 0;
const core_1 = require("@veeam/core");
const core_2 = require("../../core");
var CONFIGURATION_BACKUP_STATUS;
(function (CONFIGURATION_BACKUP_STATUS) {
    CONFIGURATION_BACKUP_STATUS["success"] = "success";
    CONFIGURATION_BACKUP_STATUS["failed"] = "failed";
    CONFIGURATION_BACKUP_STATUS["pending"] = "pending";
    CONFIGURATION_BACKUP_STATUS["none"] = "none";
})(CONFIGURATION_BACKUP_STATUS = exports.CONFIGURATION_BACKUP_STATUS || (exports.CONFIGURATION_BACKUP_STATUS = {}));
class ConfigurationBackupModel extends core_1.Model {
    constructor(initialValue = ConfigurationBackupModel.INITIAL_VALUE) {
        super(initialValue);
    }
    static isDailyOfKindSelectedDays(dailyOfKind) {
        return dailyOfKind === core_2.DAILY_OF_KIND.selectedDays;
    }
    static isDailyOfKindWeekdays(dailyOfKind) {
        return dailyOfKind === core_2.DAILY_OF_KIND.weekdays;
    }
    static isDailyOfKindEveryday(dailyOfKind) {
        return dailyOfKind === core_2.DAILY_OF_KIND.everyday;
    }
    static getDailyOfKind(dayOfWeek) {
        if (dayOfWeek.length === ConfigurationBackupModel.EVERYDAY.length) {
            return core_2.DAILY_OF_KIND.everyday;
        }
        else if (dayOfWeek.length === ConfigurationBackupModel.WEEKDAYS.length &&
            ConfigurationBackupModel.WEEKDAYS.every((d) => dayOfWeek.includes(d))) {
            return core_2.DAILY_OF_KIND.weekdays;
        }
        else {
            return core_2.DAILY_OF_KIND.selectedDays;
        }
    }
    static getDayOfWeekByDailyOfKind(dayOfWeek, dailyOfKind) {
        let result;
        switch (dailyOfKind) {
            case core_2.DAILY_OF_KIND.everyday:
                result = ConfigurationBackupModel.EVERYDAY;
                break;
            case core_2.DAILY_OF_KIND.weekdays:
                result = ConfigurationBackupModel.WEEKDAYS;
                break;
            case core_2.DAILY_OF_KIND.selectedDays:
            default:
                result = [...dayOfWeek];
        }
        return result;
    }
    static isSuccessStatus(status) {
        return status === CONFIGURATION_BACKUP_STATUS.success;
    }
    static isFailedStatus(status) {
        return status === CONFIGURATION_BACKUP_STATUS.failed;
    }
    static isPendingStatus(status) {
        return status === CONFIGURATION_BACKUP_STATUS.pending;
    }
}
exports.ConfigurationBackupModel = ConfigurationBackupModel;
ConfigurationBackupModel.RETENTION_COUNT_MAX = 9999;
ConfigurationBackupModel.RETENTION_COUNT_MIN = 1;
ConfigurationBackupModel.DEFAULT_TIME_LOCAL = '12:00 PM';
ConfigurationBackupModel.DEFAULT_DAY_OF_WEEK = [core_2.DAY_OF_WEEK.monday];
ConfigurationBackupModel.EVERYDAY = [
    core_2.DAY_OF_WEEK.sunday,
    core_2.DAY_OF_WEEK.monday,
    core_2.DAY_OF_WEEK.tuesday,
    core_2.DAY_OF_WEEK.wednesday,
    core_2.DAY_OF_WEEK.thursday,
    core_2.DAY_OF_WEEK.friday,
    core_2.DAY_OF_WEEK.saturday,
];
ConfigurationBackupModel.WEEKDAYS = [
    core_2.DAY_OF_WEEK.monday,
    core_2.DAY_OF_WEEK.tuesday,
    core_2.DAY_OF_WEEK.wednesday,
    core_2.DAY_OF_WEEK.thursday,
    core_2.DAY_OF_WEEK.friday,
];
ConfigurationBackupModel.INITIAL_VALUE = {
    managedBy: '',
    isScheduleEnabled: false,
    repositoryId: '',
    repositoryName: '',
    retentionCount: ConfigurationBackupModel.RETENTION_COUNT_MIN,
    retentionType: core_2.RETENTION_TYPE.days,
    timeLocal: ConfigurationBackupModel.DEFAULT_TIME_LOCAL,
    dailyOfKind: core_2.DAILY_OF_KIND.selectedDays,
    dayOfWeek: ConfigurationBackupModel.DEFAULT_DAY_OF_WEEK,
    restorePointId: '',
    restorePointCreationTime: '',
    isSessionHistoryIncluded: true,
    status: CONFIGURATION_BACKUP_STATUS.none,
};
//# sourceMappingURL=ConfigurationBackupModel.js.map